<template>
  <v-data-table elevation="12" style="width: 100%; margin-left: 10%; margin-right: 10%;" dense :headers="getHeaders"
    :items="dati" :no-data-text="''" :no-results-text="'Nessun dato trovato'" class="tableDettaglio" fixed-header
    hide-default-header hide-default-footer :page.sync="page" :items-per-page="itemsPerPage" mobile-breakpoint="0"
    @page-count="pageCount = $event" item-key="Posizione">
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th style="height: 30px !important; text-align: left; background-color: #e0e0e0;"
            v-for="(header, i) in getHeaders" :key="i">
            <span style="color: black;">{{ header }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:item="{ item }">
      <tr><!-- v-for="(item, z) in dati" :key="z" -->
        <td v-for="(header, x) in getHeaders" :style="header.style" :key="`${item.Posizione}-${x}`">
          <span>{{ item[header] }}</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    dati: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },

  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 999,
    };
  },

  methods: {
    formatValue(valore, tipo) {
      if (tipo == "Money") return "€ " + parseFloat(valore).toFixed(2);

      return valore;
    },

    changeSort(item) {
      // Controllo sort attivo
      if (!item.sortable) return;

      if (this.pagination.sortBy === item.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = item.value;
        this.pagination.descending = false;
      }
    }
  },

  computed: {
    getHeaders() {
      let h = [];

      this.dati.forEach(value => {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          if (h.indexOf(key) != -1) continue;

          h.push(key);
        }
      });

      return h;
    },
  }
};
</script>


<style scoped>
/* ---------------------- */
/*   Tabella dettaglio    */
/* ---------------------- */
table.tableDettaglio {
  table-layout: fixed;
  /*background-color: whitesmoke;*/
  border-spacing: 0px;
  margin: auto;
  box-shadow: 2px 2px 5px 0px #e0e0e0;
}

table.tableDettaglio th {
  height: 30px !important;
  text-align: left;
  background-color: #e0e0e0;
}

table.tableDettaglio th:first-child,
th:not(:first-child),
td:first-child,
td:not(:first-child) {
  padding: 5px !important;
}

table.tableDettaglio td {
  height: 30px !important;
  color: black;
  border-bottom: 1px solid lightgray;
  border-right: 1px solid #d9d9d9;
}

/* ---------------------- */
</style>
